import React from "react";
import { BrowserRouter } from "react-router-dom";

import Routes from "./js/routes/Main";

import "./scss/App.scss";

const App = () => (
  <BrowserRouter>
    <Routes/>
  </BrowserRouter>
);

export default App;
